import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import { TYPES } from '@src/constants/leaderboard';
import Typography from '@src/new-components/Typography';
import { StyledTabItem, StyledTabs } from '../index.style';

const Tabs = ({ maxPublishDaysBeforeEvent, activeTab, handleChangeTab }) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledTabs>
        {TYPES.map((tab) => (
          <StyledTabItem
            isActive={activeTab === tab.value}
            key={tab.value}
            onClick={() => handleChangeTab(tab.value)}
          >
            <Typography
              color={
                activeTab === tab.value
                  ? COLOR.darkGray
                  : COLOR.descriptionUpload
              }
              variant="body-14-medium"
            >
              {t(tab.label)}
            </Typography>
          </StyledTabItem>
        ))}
      </StyledTabs>
      <Typography
        style={{ textAlign: 'center', alignSelf: 'center' }}
        color={COLOR.descriptionUpload}
        variant="body-14-regular"
        className="tabs-description"
      >
        {activeTab === TYPES[1].value
          ? t('appliesVoiceSharedCommunityVoiceLibraryWithinLastDays', {
              days: maxPublishDaysBeforeEvent || 30,
            })
          : t('appliesAllVoicesSharedToTheCommunityVoiceLibrary')}
      </Typography>
    </>
  );
};
export default Tabs;
